import type { ClientPersonCreateRequest } from '@DigitaleDoerfer/digitale-doerfer-api';

import { useParticipantsPersonEventsApi } from '@/features/api/hooks/participant/useParticipantsPersonEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const usePersonCreate = () => {
  const api = useParticipantsPersonEventsApi();

  return useApiMutation({
    mutationFn: (clientPersonCreateRequest: ClientPersonCreateRequest) =>
      api.onPersonCreateRequest({ clientPersonCreateRequest })
  });
  /*
    Todo: invalidation here causes some unsent requests during registration. As we do not use the onboarding endpoint during the app, this might be fine
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.ONBOARDING_STATUS]
      });
  }
  */
};
